import React from 'react';
import { MODAL_TYPE_V2 } from '../../constants.js';
import { SelectionHeader } from './SelectionHeader.js';
import { DecisionHeader } from './DecisionHeader.js';
import { FormHeader } from './FormHeader.js';
import { FeedbackIcon } from './FeedbackIcon.js';
import { Footer } from './Footer.js';
import { Title } from './Title.js';
import { showForm, showSelection, showDecision, showFeedBack, showFooter } from '../helpers.js';
import { ModalWrapper, ModalContent } from '../blocks.js';
import '@elliemae/ds-basic/form/SearchBox';
import '@elliemae/ds-icons/Close';
import '@elliemae/ds-basic/Button';
import '@elliemae/ds-icons/ErrorHexegon';
import '@elliemae/ds-icons/WarningTriangle';
import '@elliemae/ds-icons/CheckmarkCircle';
import '@elliemae/ds-icons/HelpCircle';
import '@elliemae/ds-icons/InfoCircle';
import '@babel/runtime/helpers/esm/extends';
import '@babel/runtime/helpers/esm/defineProperty';
import '@elliemae/ds-classnames';

/* eslint-disable max-lines */
var DSModalContent = function DSModalContent(_ref) {
  var _ref$containerProps = _ref.containerProps,
      containerProps = _ref$containerProps === void 0 ? {} : _ref$containerProps,
      _ref$modalType = _ref.modalType,
      modalType = _ref$modalType === void 0 ? MODAL_TYPE_V2.INFORMATION : _ref$modalType,
      _ref$modalSubType = _ref.modalSubType,
      modalSubType = _ref$modalSubType === void 0 ? null : _ref$modalSubType,
      _ref$modalTitle = _ref.modalTitle,
      modalTitle = _ref$modalTitle === void 0 ? '' : _ref$modalTitle,
      _ref$showRejectButton = _ref.showRejectButton,
      showRejectButton = _ref$showRejectButton === void 0 ? false : _ref$showRejectButton,
      _ref$showClose = _ref.showClose,
      showClose = _ref$showClose === void 0 ? true : _ref$showClose,
      _ref$searchProps = _ref.searchProps,
      searchProps = _ref$searchProps === void 0 ? {} : _ref$searchProps,
      _ref$actionsRef = _ref.actionsRef,
      actionsRef = _ref$actionsRef === void 0 ? function () {
    return null;
  } : _ref$actionsRef,
      additionalFooterCssClass = _ref.additionalFooterCssClass,
      _ref$overridePropsCon = _ref.overridePropsConfirmButton,
      overridePropsConfirmButton = _ref$overridePropsCon === void 0 ? {} : _ref$overridePropsCon,
      _ref$overridePropsRej = _ref.overridePropsRejectButton,
      overridePropsRejectButton = _ref$overridePropsRej === void 0 ? {} : _ref$overridePropsRej,
      children = _ref.children,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? function () {
    return null;
  } : _ref$onClose,
      _ref$onConfirm = _ref.onConfirm,
      onConfirm = _ref$onConfirm === void 0 ? function () {
    return null;
  } : _ref$onConfirm,
      _ref$onReject = _ref.onReject,
      onReject = _ref$onReject === void 0 ? function () {
    return null;
  } : _ref$onReject,
      _ref$rejectLabel = _ref.rejectLabel,
      rejectLabel = _ref$rejectLabel === void 0 ? 'Discard' : _ref$rejectLabel,
      _ref$confirmLabel = _ref.confirmLabel,
      confirmLabel = _ref$confirmLabel === void 0 ? 'Save' : _ref$confirmLabel,
      _ref$removePadding = _ref.removePadding,
      removePadding = _ref$removePadding === void 0 ? false : _ref$removePadding;
  return /*#__PURE__*/React.createElement(ModalWrapper, containerProps, showForm({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(FormHeader, {
    modalTitle: modalTitle,
    modalType: modalType,
    onClose: onClose,
    showClose: showClose
  }), showSelection({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(SelectionHeader, {
    modalTitle: modalTitle,
    modalType: modalType,
    searchProps: searchProps,
    showClose: showClose
  }), showDecision({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(DecisionHeader, {
    onClose: onClose,
    showClose: showClose
  }), showFeedBack({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(FeedbackIcon, {
    modalSubType: modalSubType
  }), showDecision({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(Title, {
    modalTitle: modalTitle,
    modalType: modalType
  }), /*#__PURE__*/React.createElement(ModalContent, {
    classProps: {
      type: modalType,
      removePadding: removePadding
    }
  }, children), showFooter({
    modalType: modalType,
    modalSubType: modalSubType
  }) && /*#__PURE__*/React.createElement(Footer, {
    actionsRef: actionsRef,
    additionalFooterCssClass: additionalFooterCssClass,
    confirmLabel: confirmLabel,
    onConfirm: onConfirm,
    onReject: onReject,
    overridePropsConfirmButton: overridePropsConfirmButton,
    overridePropsRejectButton: overridePropsRejectButton,
    rejectLabel: rejectLabel,
    showRejectButton: showRejectButton
  }));
};

export { DSModalContent };
//# sourceMappingURL=ModalContent.js.map
